var api = "https://api.qingcigame.com";
var videoList = []
var artList = []
var swiper4 = null
var imgIndex = 0
var videoIndex = 0
var pageIndex = 1
var tColor = ''
var initialSlide = 0;

var obj = {
    index: function() {
        this.preloading(); // 预加载
        // this.indexSwiper(); // 首页大轮播
        this.mapPopup(); //地图探索弹窗
        this.jqslideTxtBox(); // 游戏咨询信息切换
        this.Textlength(28, 25); // 内容字体长度超过40，标题字体长度超过25
        this.indexBind(); // 首页按钮
        this.share(); // 分享链接
        this.urlAjax(); //社媒平台链接合集
        this.appointmentAjax(); //预约按钮
        this.appointmentNumber(); //预约人数
        this.countNum(); //阿里云埋点
    },
    // 首页暂未开放的几个按钮
    indexBind: function() {
        $('.monitor-btn').on('click', function() {
            var mon_btn = $(this).attr('data-event');
            obj.countNum(mon_btn);
        })

        // 预约登录
        $('.email-appointment-btn').click(function(event) {
            var email = $('.email-inp').val();
            var code = $('.code-inp').val();
            // var os = $('.box-type').find('.select').attr('os');
            var agreement = $('.agreement-selection');

            var state1 = "您填写的邮箱格式不正确，请重新填写";
            var state2 = "您填写的验证码格式不正确，请重新填写";
            var state3 = "邮箱已注册";
            var state4 = "连接时间请刷新窗口";
            var state5 = "请同意隐私政策";
            var state6 = "预约失败 <br/> 请检查邮箱与验证码是否输入有误"

            if (!email) {
                layer.msg(state1, { time: 2000 });
                return false;
            }
            if (!code) {
                layer.msg(state2, { time: 2000 });
                return false;
            }
            if (!agreement.hasClass('select')) {
                layer.msg(state5, { time: 2000 });
                return false;
            }

            email == 123 && code == 123 ? success() : fail();

            function success() {
                $('.popup').fadeOut();
                $('.success-wrap').fadeIn();
                $('.phone-inp').val('');
            }

            function fail() {
                $('.popup').fadeOut();
                $('.fail-wrap').fadeIn();
                $('.fail-info p').html(state6);
            }


            // index = layer.load(2, { shade: [0.1, '#fff'] });
            // setTimeout(function() {
            //     $.ajax({
            //         url: "http://tapi.qingcigame.com/jpweb/reserve/user/info",
            //         type: "POST",
            //         xhrFields: {
            //             withCredentials: true
            //         },
            //         data: {
            //             jp_email: email,
            //             code: code,
            //         },
            //         dataType: 'json',
            //         error: function() {
            //             layer.msg("请求失败，请联系客服")
            //         },
            //         success: function(json) {
            //             // 第一次 || 第二次预约操作进入
            //             if (json.code == 200 || json.code == 404) {
            //                 $('.popup').fadeOut();
            //                 $('.success-wrap').fadeIn();
            //                 $('.phone-inp').val('');
            //             } else if (json.code == 401) {
            //                 $('.popup').fadeOut();
            //                 $('.fail-wrap').fadeIn();
            //                 $('.fail-info p').html(state1);
            //             } else if (json.code == 402) {
            //                 $('.popup').fadeOut();
            //                 $('.fail-wrap').fadeIn();
            //                 $('.fail-info p').html(state3);
            //             } else if (json.code == 408) {
            //                 $('.popup').fadeOut();
            //                 $('.fail-wrap').fadeIn();
            //                 $('.fail-info p').html(state4);
            //             } else {
            //                 layer.msg(json.message, { time: 2000 });
            //             }
            //         },
            //         complete: function() {
            //             layer.close(index);
            //         }
            //     });
            // }, 1000)

        });

        // 验证码判断
        $('.get-code-btn').on('click', function(event) {
            var email = $('.email-inp').val();
            if (!email) {
                layer.msg("请输入邮箱", { time: 2000 });
                email.focus();
                return false;
            }

            time()

            // var index = layer.load(1);
            // $.ajax({
            //     // url: "//sdk.qcplay.com/v3/send/sms",
            //     url: 'http://tapi.qingcigame.com/jpweb/reserve/user/code',
            //     type: "POST",
            //     data: {
            //         email: email,
            //     },
            //     error: function() {
            //         layer.msg("请求失败,请联系客服")
            //     },
            //     success: function(json) {
            //         if (json.code != 200) {
            //             layer.msg(json.message);
            //             return;
            //         } else {
            //             // 倒计时
            //             time();
            //         }
            //     },
            //     complete: function() {
            //         layer.close(index)
            //     }
            // });
        });

        // 60s倒计时
        var wait = 60;

        function time() {
            if (wait == 0) {
                $('.get-code-btn p').remove();
                $('.get-code-btn').html("<div class='btn-box'></div>");
                wait = 60;
            } else {
                $('.get-code-btn div').remove();
                $('.get-code-btn').html("<p>" + wait + "秒</p>");
                wait--;
                setTimeout(function() {
                    time()
                }, 1000)
            }
        }

        // 点击预约弹窗
        // $('.appointment-btn').click(function(event) {
        //     $('.appointment-wrap').fadeIn();
        // });

        // 关闭按钮
        $('.close-btn').click(function(event) {
            $('.popup').fadeOut()
        });

        // 选择操作系统
        $('.box-type').on('click', 'b', function(event) {
            $(this).addClass('select').siblings().removeClass('select');
            // 对选择不同操作系统预约成功的人做监控
            $(".and").hasClass('select') ? $(".success-box .close-btn").attr("data-event", "and-pre") : $(".success-box .close-btn").attr("data-event", "ios-pre");
        });

        // 同意隐私政策
        $('.agreement-selection').on('click', function(event) {
            var _this = $(this);
            _this.hasClass('select') ? _this.removeClass('select') : _this.addClass('select');
        });

        $('.fail-wrap').on('click', '.close-btn', function(event) {
            $('.fail-wrap').fadeOut()
            $('.appointment-wrap').fadeIn();
        });

        $('.success-wrap').on('click', '.close-btn', function(event) {
            $('.popup').fadeOut()
        });

        //暂未开放
        // $('.ios-btn,.app-btn').on('click', function() {
        //     layer.msg("Coming soon. Please stay tuned!", { time: 2000 });
        // });

        // 三个按钮随机晃动
        var activeIdx = 0;

        function getRandomIdx() {
            // 获取随机数
            var curActiveIdx = Math.floor(Math.random() * (3)) + 1;
            if (activeIdx === curActiveIdx) {
                curActiveIdx = getRandomIdx();
            }
            return curActiveIdx;
        }

        function randomAni() {
            var newIdx = getRandomIdx();
            $('.part').removeClass('shake-ani');
            $('.part-btn-0' + newIdx).addClass('shake-ani')
            activeIdx = newIdx;
        }

        // 抽奖机工作
        // $(".machine").on('click', function() {
        $(".guide").remove() //指引
        $(".shadow").remove() //悬停亮光
            //     $(".machine").addClass("machine-ani") //抽奖机运转
            //     setTimeout(function() {
            //         $(".machine").removeClass("machine-ani") //抽奖机暂停
            //         $(".drawer").addClass("show") //出蛋开始
            //         setTimeout(function() {
            //             $(".award-pop").fadeIn() //奖励弹窗弹出
            //             $(".drawer").removeClass("show") //出蛋隐藏
            //         }, 1500)
            //     }, 4000)
            //     $(".machine").off("click"); //抽奖机点击失效
            // });

        // 领取按钮
        // $(".get-btn").on('click', function() {
        $(".award-pop").fadeOut() // 奖励弹窗消失
        $(".machine").addClass("disable-hover") // 抽奖机悬停亮光失效

        // 三个零件开始随机晃动
        var timer = setInterval(function() {
            randomAni()
        }, 1800)

        // 抽奖机故障动画
        $(".machine").addClass("skew-ani");
        setTimeout(function() {
                $(".smoke").show(); // 故障烟雾
                setTimeout(function() {
                    $(".part-box").fadeIn() //三个零件弹出
                }, 100)

                $(".machine").hide() // 原抽奖机隐藏 出现故障抽奖机
                $(".machine").removeClass("skew-ani");

                $(".tips").addClass("fix") // 气泡弹窗 提示去修理
            }, 1500)
            // });

        // 点击零件 弹窗
        $(".part-box .part").on('click', function() {
            let pIndex = $(this).attr("data");
            layer.msg('Found a piece of the lottery machine', { time: 1500 });
            switch (pIndex) {
                case "1":
                    $(".facebook-pop").fadeIn();
                    $(".facebook-btn").remove();
                    break;
                case "2":
                    $(".youtube-pop").fadeIn();
                    $(".youtube-btn").remove();
                    break;
                case "3":
                    $(".twitter-pop").fadeIn();
                    $(".twitter-btn").remove();
                    break;
                default:
                    return false
            }
        });

        function finishFixed() {
            if ($(".part-box").children().length == 0) {
                $(".tips").removeClass("fix").addClass("receive");
                $(".bag div").addClass("bag-tips");
                $(".smoke").remove();
                $(".machine").show();
                setTimeout(function() {
                    $(".tips-award-pop").fadeIn(); //奖励提示弹窗弹出
                }, 600);
            }
        }

        // 视频播放
        var Media = document.getElementById('media-play');
        $('.videos-btn').on('click', function(event) {
            var _this = $(this)
            var data = _this.parents().attr('data')
            $('.popup-video').fadeIn().find('video').attr('src', data);
            Media.play();
        });

        // 首屏播放视频
        $('.video-btn').on('click', function(event) {
            var _this = $(this)
            var data = _this.attr('data')
                // var data = $(this).attr('data');
            $('.popup-video').fadeIn().find('video').attr('src', data);
            Media.play();
        });

        $('.embedded').on('click', '.close-btn', function(event) {
            $('.popup').fadeOut();
            finishFixed() //修复完成
        });

        // 关闭按钮 关闭视频
        $('.close-btn').click(function(event) {
            $('.popup').fadeOut().find('video').attr('src', '');
            Media.pause();
        });

        // 奖励按钮
        $(".bag div").click(function(event) {
            $(".tips-award-pop").fadeIn();
        });

        // 抽奖机活动详情按钮
        $('.detail-btn').click(function(event) {
            $(".detail-pop").fadeIn();
        });

        // MEDIA 图片弹窗
        // $('.art img').on('click', function() {
        //     var imgSrc = $(this).attr('src');
        //     console.log(1111111111, imgSrc);
        //     $('.popup-img').fadeIn().find('img').attr('src', imgSrc);
        // });

        $('.art span').on('click', function() {
            var _this = $(this).siblings('img')
            var imgSrc = $(_this).attr('src');
            $('.popup-img').fadeIn().find('img').attr('src', imgSrc);
        })

        // 蜗牛按钮
        $('.role-ani').click(function(event) {
            var _this = $(this);
            if (!_this.hasClass('rubberBand2'))
                _this.addClass('rubberBand2')
            setTimeout(function() { _this.removeClass('rubberBand2') }, 1000);
        });

        // $('.news-btn').on('click', 'li', function(event) {
        //     $(this).addClass('on').siblings('li').removeClass('on');
        // });

        // 点击背景关闭弹窗
        $('.popup_wrap').click(function(event) {
            if ($(event.target)[0] == $(this)[0]) {
                $('.popup').fadeOut().find('video').attr('src', '');
                Media.pause();
                $('.popup_wrap').fadeOut();
            }
        });

    },
    // iframe数据导入
    newsIframe: function() {
        var id = this.getQueryVariable('id');
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: "//api.qcplay.com/web/article/" + id + "",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var detailsInfo = json.data.list.article_content; // 内容
                    $('body .iframe').append(detailsInfo);
                } else {
                    layer.msg("Server not available", { time: 2000 });
                }
            },
            error: function() {
                layer.msg("Server not available", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },

    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;

        }, this);
        queue.on("error", function(e) {
            console.log('loading images fail', e)
        })
        queue.on("complete", function(e) {
            //加载完成执行操作
            var _this = this;
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.index').addClass('index-show');
            this.indexSwiper();
            // $('.recommend-popup').fadeIn();     // 新增加弹窗
            setTimeout(function() {
                $('.preloading').remove();
                // _this.twitterShare(); // twitter分享
                // _this.facebookShare(); // facebook分享
                // _this.youtubeShare(); // youtube分享
            }, 1000)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '/pre-order/images/pc/m_dt_sz-d35ae8162e.png',
            '/pre-order/images/pc/m_dt_t-4dce075ef4.png',
            '/pre-order/images/pc/m_jdt-53c40dabf1.png',
            '/pre-order/images/pc/header_bg-4cf5fdb715.png',
            '/pre-order/images/pc/index_bg-89686d1bfe.png',
            '/pre-order/images/pc/app_store-6d69d4da1a.png',
            '/pre-order/images/pc/google_btn-0cc31d9590.png',
            '/pre-order/images/pc/official_btn-ab298ddce3.png',
            '/pre-order/images/pc/video_btn-77e7b31138.png',
            '/pre-order/images/pc/video_btn_bg-2b266a5a84.png',
        ]);
    },
    // 全屏滚动判断
    scroll: function() {
        $(window).scroll(function() {
            var scrollTop = $(this).scrollTop();
            var scrollHeight = $(document).height();
            var windowHeight = $(this).height();
            $(document).scrollTop() > 400 ? $('.return-top').fadeIn() : $('.return-top').fadeOut();
        });

        $('.return-top').click(function(event) {
            $(document).scrollTop(0);
        });
    },
    // 首页轮播
    indexSwiper: function() {
        var mySwiper2 = new Swiper('.swiper-container-worldview', {
            loop: true,
            paginationClickable: true,
            noSwiping: true,
            autoplay: 2000,
            autoplayDisableOnInteraction: false,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            effect: 'coverflow',
            centeredSlides: true,
            slidesPerView: 'auto',
            loopedSlides: '5',
            observer: true,
            observerParents: true,
            initialSlide: 3,
            speed: 700,
            coverflow: {
                rotate: -30, // 旋转的角度
                stretch: 5, // 拉伸   图片间左右的间距和密集度
                depth: 30, // 深度   切换图片间上下的间距和密集度
                modifier: 10, // 修正值 该值越大前面的效果越明显
                // slideShadows : false// 页面阴影效果
            },
            onInit: function(swiper) {
                swiperAnimate(swiper);
                swiper.stopAutoplay();
            },
        })
        var mySwiper = new Swiper('.swiper-container', {
            pagination: '.swiper-pagination',
            direction: 'vertical',
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 0,
            initialSlide: initialSlide,
            mousewheelControl: true,
            resistanceRatio: 0,
            onInit: function(swiper) {
                swiperAnimate(swiper);

                function Ani(btn, page) {
                    $(btn).on('click', function() {
                        mySwiper.slideTo(page, 1000, true);
                    });
                };

                function navLink() {
                    for (var i = 4; i >= 0; i--) {
                        Ani('.nav-link-0' + i + ' .link-a', i);
                    };
                }
                navLink();
            },
            onSlideChangeEnd: function(swiper) {
                swiperAnimate(swiper);
                swiper.activeIndex !== 0 ? $('.header').addClass('header-shadow') : $('.header').removeClass('header-shadow');
                swiper.activeIndex >= 4 ? $('.rocket').fadeIn() : $('.rocket').fadeOut();
                $('.nav-link').removeClass('on')
                $('.nav-link-0' + swiper.activeIndex + '').addClass('on');
            },
        });
        $('body').on('click', '.rocket', function(event) {
            var _this = $(this);
            _this.addClass('rocket-ani')
            mySwiper.slideTo(0, 1000, true);
            setTimeout(function() { _this.fadeOut() }, 1000);
            setTimeout(function() { _this.removeClass('rocket-ani') }, 1500);
        });
    },
    // 地图探索弹窗
    mapPopup: function() {
        //开启弹窗
        $('.map-explore').on('click', 'li', function(event) {
            let id = $(this).attr("id");
            if ($(this).hasClass("light")) {
                $('.map-popup').fadeIn();
            } else {
                layer.msg("Coming soon. Please stay tuned!", { time: 2000 });
            }

            $('.map-popup .title').addClass("map-t-0" + id); // 标题
            $('.map-popup .content').addClass("map-c-0" + id); // 内容
        });

        // 关闭弹窗
        $('.map-popup').on('click', '.close-btn', function(event) {
            $('.map-popup').fadeOut();
            $('.map-popup .title').attr("class", "title");
            $('.map-popup .content').attr("class", "content");
        });

        $('.map-explore li:nth-child(1)').find('a').attr('href', 'introduction-list-mobile.html?cate_id=17&page=1');
    },
    // 游戏咨询信息切换
    jqslideTxtBox: function() {
        // 首页第二页游戏介绍信息
        jQuery(".txtMarquee-right").slide({ mainCell: ".bd ul", autoPlay: true, effect: "topMarquee", vis: 10, interTime: 50, mouseOverStop: false });
        jQuery(".slideTxtBox").slide({ effect: "leftLoop", trigger: "click", easing: "easeOutElastic" });
        jQuery(".slideTxtBox-02").slide({ effect: "top", trigger: "click", easing: "easeOutElastic" });
        jQuery(".slideTxtBox-03 .bd-bg").slide({ mainCell: ".bd ul", autoPlay: true, delayTime: 1000 });
    },
    // 内容字体长度超过40，标题字体长度超过25
    Textlength: function(x1, x2) {

        $('.slideTxtBox .bd p').each(function() {
            if ($(this).text().length > x1) {
                var str = $(this).text();
                $(this).text(str.substr(0, x1) + '...');
            }
        });
        $('.slideTxtBox .bd h2').each(function() {
            if ($(this).text().length > x2) {
                var str = $(this).text();
                $(this).text(str.substr(0, x2) + '...');
            }
        });
    },
    // 获取当前hash的具体参数
    getQueryVariable: function(variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    share: function() {
        $.ajax({
            url: api + "/wechat/jssdk",
            type: "POST",
            data: {
                uri: window.location.href,
            },
            success: function(json) {

                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    wx.config(json.data);
                    wx.ready(function() {
                        wx.updateAppMessageShareData({
                            title: '最强蜗牛', // 分享标题
                            desc: '大家都爱玩的沙雕手游', // 分享描述
                            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: '//static.qcplay.com/common/snail_icon.png', // 分享图标
                            success: function() {}
                        })

                        wx.updateTimelineShareData({
                            title: '最强蜗牛-大家都爱玩的沙雕手游', // 分享标题
                            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: '//static.qcplay.com/common/snail_icon.png', // 分享图标
                            success: function() {
                                // 设置成功
                            }
                        })
                    });
                    return;
                } else {
                    try {
                        setShareInfo({
                            title: '最强蜗牛', // 分享标题
                            summary: '大家都爱玩的沙雕手游', // 分享内容
                            pic: '//static.qcplay.com/common/snail_icon.png', // 分享图片
                            url: window.location.href, // 分享链接
                            // 微信权限验证配置信息，若不在微信传播，可忽略
                            WXconfig: {
                                swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
                                appId: json.data.appId, // 公众号的唯一标识
                                timestamp: json.data.timestamp, // 生成签名的时间戳
                                nonceStr: json.data.nonceStr, // 生成签名的随机串
                                signature: json.data.signature // 签名
                            }
                        });
                    } catch (err) {}
                }
            }
        })
    },
    twitterShare: function() {
        // 插入推特推广
        $('.twitter-box').append('<a class="twitter-timeline" href="https://twitter.com/SuperSnailUS?ref_src=twsrc%5Etfw">Tweets by SuperSnailUS</a> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>');
        window.twttr = (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0],
                t = window.twttr || {};
            if (d.getElementById(id)) return t;
            js = d.createElement(s);
            js.id = id;
            js.src = "//platform.twitter.com/widgets.js";
            fjs.parentNode.insertBefore(js, fjs);

            t._e = [];
            t.ready = function(f) {
                t._e.push(f);
            };
            return t;
            var _iframe = document.createElement('iframe').contentWindow.document.body.find('a') //get iframe下的id
            _iframe.style.opacity = 0; //修改样式
        }(document, "script", "twitter-wjs"));
    },
    facebookShare: function() {
        // 插入facebook推广
        // $(".facebook-box").html("facebookShare");
        $('.facebook-box').append('<a class="twitter-timeline" data-lang="ja" href="//twitter.com/MARVELOUS_SNAIL?ref_src=twsrc%5Etfw">Tweets by MARVELOUS_SNAIL</a> <script async src="//platform.twitter.com/widgets.js" charset="utf-8"></script>');

        window.twttr = (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0],
                t = window.twttr || {};
            if (d.getElementById(id)) return t;
            js = d.createElement(s);
            js.id = id;
            js.src = "//platform.twitter.com/widgets.js";
            fjs.parentNode.insertBefore(js, fjs);

            t._e = [];
            t.ready = function(f) {
                t._e.push(f);
            };
            return t;
            var _iframe = document.createElement('iframe').contentWindow.document.body.find('a') //get iframe下的id
            _iframe.style.opacity = 0; //修改样式
        }(document, "script", "twitter-wjs"));
    },
    youtubeShare: function() {
        // 插入youtube推广
        $(".youtube-box").html("youtubeShare");
        $('.youtube-box').append('<a class="twitter-timeline" data-lang="ja" href="//twitter.com/MARVELOUS_SNAIL?ref_src=twsrc%5Etfw">Tweets by MARVELOUS_SNAIL</a> <script async src="//platform.twitter.com/widgets.js" charset="utf-8"></script>');
        window.twttr = (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0],
                t = window.twttr || {};
            if (d.getElementById(id)) return t;
            js = d.createElement(s);
            js.id = id;
            js.src = "//platform.twitter.com/widgets.js";
            fjs.parentNode.insertBefore(js, fjs);

            t._e = [];
            t.ready = function(f) {
                t._e.push(f);
            };
            return t;
            var _iframe = document.createElement('iframe').contentWindow.document.body.find('a') //get iframe下的id
            _iframe.style.opacity = 0; //修改样式
        }(document, "script", "twitter-wjs"));
    },
    urlAjax: function() {
        var facebookUrl = '//www.facebook.com/SuperSnailOfficial';
        var twitterUrl = '//twitter.com/SuperSnailUS';
        var youtubeUrl = '//www.youtube.com/@supersnailofficial';
        var redditUrl = '//www.reddit.com/r/SuperSnail_US/';
        var instagramUrl = '//www.instagram.com/supersnailofficial/';
        var discordUrl = '//discord.gg/qz67feyaZe';

        $('.facebook').attr('href', facebookUrl);
        $('.twitter').attr('href', twitterUrl);
        $('.youtube').attr('href', youtubeUrl);
        $('.reddit').attr('href', redditUrl);
        $('.instagram').attr('href', instagramUrl);
        $('.discord').attr('href', discordUrl);

    },
    // 预约按钮
    appointmentAjax: function() {
        $('.google-btn , .ios-btn, .app-btn, .appointment-btn').click(function(event) {
            var index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: "//api.qingcigame.com/thai/info",
                type: "POST",
                xhrFields: {
                    withCredentials: true
                },
                dataType: 'json',
                success: function(json) {
                    // 第一次 || 第二次预约操作进入
                    // console.log(json.message);
                },
                complete: function() {
                    layer.close(index);
                }
            });
        });
    },
    // 预约人数
    appointmentNumber: function() {
        $.ajax({
            url: '//api.qingcigame.com/thai/reserve/number',
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                var number = json.data.total_number;
                if (json.code == 200) {
                    var num = number.toString().replace(/(?=(\B\d{3})+$)/g, ',')
                    $('.appointments-number span').html(num);

                    if (number <= 50000) {
                        // $('.map-box').addClass('got-01')
                    } else if (number >= 50000 && number < 100000) {
                        $('.map-box').addClass('got-01');
                    } else if (number >= 100000 && number < 300000) {
                        $('.map-box').addClass('got-02');
                    } else if (number >= 30000 && number < 500000) {
                        $('.map-box').addClass('got-03');
                    } else if (number >= 500000 && number < 777000) {
                        $('.map-box').addClass('got-04');
                    } else if (number >= 777000 && number < 1000000) {
                        $('.map-box').addClass('got-05');
                    } else {
                        $('.map-box').addClass('got-06');
                    }


                } else {
                    layer.msg("Server not available", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("Server not available", { time: 2000 });
            },
            complete: function() {
                // layer.close(index);
            }
        })
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    }
}